export const updateQuestion = (payload?: any) => ({
    type: "@saga/UPDATE_QUESTION",
    payload
});

